import React from 'react';

// Define the categories object
const repairCategories = {
  aftertreatment: {
    name: 'Aftertreatment',
    subcategories: {
      def: 'DEF System',
      dpf: 'DPF System',
      egr: 'EGR System',
      scr: 'SCR System',
      sensors: 'Emissions Sensors'
    }
  },
  brakes: {
    name: 'Brakes',
    subcategories: {
      abs: 'ABS System',
      air: 'Air System',
      mechanical: 'Mechanical',
      parking: 'Parking Brake'
    }
  },
  chassis: {
    name: 'Chassis',
    subcategories: {
      fifth_wheel: 'Fifth Wheel',
      frame: 'Frame',
      steering: 'Steering',
      suspension: 'Suspension',
      wheels: 'Wheels & Tires'
    }
  },
  drive_axles: {
    name: 'Drive Axles',
    subcategories: {
      axle_shafts: 'Axle Shafts',
      bearings: 'Bearings',
      carrier: 'Carrier',
      differential: 'Differential',
      housing: 'Housing',
      hub_assembly: 'Hub Assembly',
      ring_pinion: 'Ring and Pinion',
      weldments: 'Weldments',
      wheel_ends: 'Wheel Ends',
      wheel_seals: 'Wheel Seals'
    }
  },
  driveline: {
    name: 'Driveline',
    subcategories: {
      carrier_bearing: 'Carrier Bearing',
      center_bearing: 'Center Bearing',
      input_yoke: 'Input Yoke',
      interaxle_driveshaft: 'Interaxle Driveshaft',
      main_driveshaft: 'Main Driveshaft',
      output_yoke: 'Output Yoke',
      slip_yoke: 'Slip Yoke',
      splines: 'Splines',
      u_joints: 'U-Joints'
    }
  },
  electrical: {
    name: 'Electrical',
    subcategories: {
      charging: 'Charging System',
      instruments: 'Instruments & Gauges',
      lighting: 'Lighting',
      starting: 'Starting System',
      wiring: 'Wiring Harness'
    }
  },
  engine: {
    name: 'Engine',
    subcategories: {
      cooling: 'Cooling System',
      ecm: 'Engine Control Module',
      fuel: 'Fuel System',
      mechanical: 'Mechanical',
      turbo: 'Turbocharger'
    }
  },
  hvac: {
    name: 'HVAC',
    subcategories: {
      ac: 'Air Conditioning',
      controls: 'Climate Controls',
      heating: 'Heating System'
    }
  },
  pdi: {
    name: 'PDI',
    subcategories: {
      custom_spec: 'Custom Specifications',
      dealer_prep: 'Dealer Preparation',
      new_truck: 'New Truck PDI',
      quality_check: 'Final Quality Check',
      used_truck: 'Used Truck Inspection',
      warranty_reg: 'Warranty Registration'
    }
  },
  pm: {
    name: 'Preventive Maintenance',
    subcategories: {
      a_service: 'A Service',
      annual: 'Annual Inspection',
      b_service: 'B Service',
      dot: 'DOT Inspection',
      filter: 'Filter Service',
      lubrication: 'Lubrication Service',
      oil_change: 'Oil Change'
    }
  },
  transmission: {
    name: 'Transmission',
    subcategories: {
      clutch: 'Clutch System',
      electronic: 'Electronic Control',
      hydraulic: 'Hydraulic System',
      mechanical: 'Mechanical'
    }
  }
};

// Create the React component
const RepairCategories = ({ selectedCategory, selectedSubcategory, onChange }) => {
  const handleCategoryChange = (e) => {
    const category = e.target.value;
    const firstSubcategory = category ? Object.keys(repairCategories[category].subcategories)[0] : '';
    onChange({ category, subcategory: firstSubcategory });
  };

  const handleSubcategoryChange = (e) => {
    onChange({ category: selectedCategory, subcategory: e.target.value });
  };

  return (
    <div>
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>
          Repair Category:
          <select
            value={selectedCategory}
            onChange={handleCategoryChange}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
            required
          >
            <option value="">Select Category</option>
            {Object.entries(repairCategories).map(([key, category]) => (
              <option key={key} value={key}>
                {category.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      {selectedCategory && (
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>
            Subcategory:
            <select
              value={selectedSubcategory}
              onChange={handleSubcategoryChange}
              style={{
                width: '100%',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ccc'
              }}
              required
            >
              {Object.entries(repairCategories[selectedCategory].subcategories).map(([key, name]) => (
                <option key={key} value={key}>
                  {name}
                </option>
              ))}
            </select>
          </label>
        </div>
      )}
    </div>
  );
};

export default RepairCategories;